import type { AbilityDescriptor, AppAbility } from "./types";

// subjects → OR: visible if user can act on any one
// actions  → AND: all actions must be allowed
export function canCheck(
	ability: AppAbility,
	descriptor: AbilityDescriptor | "all" | null,
): boolean {
	if (descriptor === null) return false;
	if (descriptor === "all") return true;
	const actions = Array.isArray(descriptor.action)
		? descriptor.action
		: [descriptor.action];
	const subjects = Array.isArray(descriptor.subject)
		? descriptor.subject
		: [descriptor.subject];
	return subjects.some((s) =>
		// biome-ignore lint/suspicious/noExplicitAny: CASL subject type is string-based at runtime
		actions.every((a) => ability.can(a as any, s as any)),
	);
}
